// mCaptcha PoW solver — utilisé sur les 4 formulaires publics de soumission
// (org/tender/event/document). Le serveur ARKO mCaptcha renvoie une config
// PoW (salt, string, difficulté), on la résout dans un Web Worker, on
// renvoie nonce+result pour récupérer le token signé à transmettre au form.
//
// Usage :
//   import { runMcaptcha } from "../lib/mcaptcha"
//   runMcaptcha({ mcaptcha_url, mcaptcha_sitekey }).then(token => ...)

export function runMcaptcha(cfg) {
  return fetch(cfg.mcaptcha_url + '/api/v1/pow/config', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key: cfg.mcaptcha_sitekey })
  })
    .then(r => r.json())
    .then(powCfg => {
      return solvePoW(powCfg.salt, powCfg.string, powCfg.difficulty_factor).then(result => {
        return fetch(cfg.mcaptcha_url + '/api/v1/pow/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            key: cfg.mcaptcha_sitekey,
            nonce: result.nonce,
            result: result.result,
            string: powCfg.string
          })
        })
      })
    })
    .then(r => r.json())
    .then(res => {
      if (res.token) return res.token
      throw new Error('No token')
    })
}

function solvePoW(salt, str, difficulty) {
  const workerCode = `self.onmessage=async function(e){
    var salt=e.data.salt,str=e.data.str,diff=e.data.difficulty;
    var enc=new TextEncoder();
    var u128max=(1n<<128n)-1n;
    var threshold=u128max-u128max/BigInt(diff);
    var saltBytes=enc.encode(salt);
    var strBytes=enc.encode(str);
    var lenBuf=new ArrayBuffer(8);
    var lenView=new DataView(lenBuf);
    lenView.setUint32(0,strBytes.length,true);
    lenView.setUint32(4,0,true);
    var lenBytes=new Uint8Array(lenBuf);
    var prefix=new Uint8Array(saltBytes.length+8+strBytes.length);
    prefix.set(saltBytes,0);
    prefix.set(lenBytes,saltBytes.length);
    prefix.set(strBytes,saltBytes.length+8);
    for(var n=0;n<5e8;n++){
      var nonceBytes=enc.encode(String(n));
      var input=new Uint8Array(prefix.length+nonceBytes.length);
      input.set(prefix,0);input.set(nonceBytes,prefix.length);
      var buf=await crypto.subtle.digest("SHA-256",input);
      var bytes=new Uint8Array(buf);
      var val=0n;for(var i=0;i<16;i++){val=(val<<8n)|BigInt(bytes[i]);}
      if(val>=threshold){
        self.postMessage({nonce:n,result:val.toString()});return;
      }
    }
    self.postMessage({error:"timeout"});
  };`

  const blob = new Blob([workerCode], { type: 'application/javascript' })
  const worker = new Worker(URL.createObjectURL(blob))
  return new Promise((resolve, reject) => {
    worker.onmessage = (e) => {
      worker.terminate()
      if (e.data.error) reject(new Error(e.data.error))
      else resolve(e.data)
    }
    worker.postMessage({ salt, str, difficulty })
  })
}
